import {DocumentNode, gql} from "@apollo/client";

export const NODE_INFO_QUERY: DocumentNode = gql(`    
    query GetNodeInfo {
      getNodeInfo {
        ...NodeInfo
      }
    }
`);
